import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import {
  updateCustomQuestions,
  updateSelectedQuestion,
} from "../../../../../store/steps/stepFourSlice";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import { STATIC_STRINGS } from "../../../../../utils/Constants";
import QuestionOption from "./QuestionOption";

const QuestionSelection = ({ openModal }) => {
  const dispatch = useDispatch();
  const { customQuestions, selectedQuestions } = useSelector(
    (state: RootState) => state.stepFour
  );

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    question:
      | { name: string; include: boolean }
      | { question: string; questionType: string; include: boolean }
  ) => {
    if ("question" in question) {
      dispatch(
        updateCustomQuestions({
          question: question.question,
          questionType: question.questionType,
          include: event.target.checked,
        })
      );
    } else {
      dispatch(
        updateSelectedQuestion({
          name: question.name,
          include: event.target.checked,
          index: selectedQuestions.findIndex((q) => q.name === question.name),
        })
      );
    }
  };

  return (
    <div className="mt-1">
      <div className="font-semibold py-2">
        {STATIC_STRINGS.QUESTIONS_AT_START}
      </div>
      <div className="grid grid-cols-4 xl:grid-cols-5 gap-2">
        {[...selectedQuestions, ...customQuestions].map((question) => (
          <QuestionOption
            key={question.name || question.question}
            id={question.name || question.question}
            checked={question.include}
            onChange={(e) => handleCheckboxChange(e, question)}
            label={question.name || question.question}
          />
        ))}
        <button
          onClick={openModal}
          className="btn btn-outline p-1 flex items-center justify-center"
        >
          <AddCircleOutline />
          <div className="ml-1">{STATIC_STRINGS.ADD_CUSTOM_QUESTION}</div>
        </button>
      </div>
    </div>
  );
};

export default QuestionSelection;
